import { ProgressSpinner } from 'primereact/progressspinner'
import Collapse from '@material-ui/core/Collapse'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'
import CancelIcon from '@material-ui/icons/Cancel'
import DoneAllIcon from '@material-ui/icons/DoneAll'
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import classNames from 'classnames'
import { Button } from 'primereact/button'
import { Messages } from 'primereact/messages'
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import axiosClient from '.././src/constants'





const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 660,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  table: {
    width: '100%',
    maxWidth: 460,
  },
}));
const AppJobMenu = (props) => {
  const [jobsList, setJobsList] = useState([]);
  const messages = useRef(null);
  const [loading, setLoading] = useState(true)
  const refresh = () => {
    axiosClient.get('/job/latest-jobs-queue').then(res => {
      if (res && res.status === 200) {
        setJobsList(res.data);
        setLoading(false)
      } else {
        messages.current.show({ severity: 'error', summary: 'Error', detail: 'Could not fetch jobs in queue' });
        setLoading(false)
      }
    })
  };
  useEffect(refresh, []);
  const classes = useStyles();
  const [id, setId] = useState(-1);
  const role = localStorage.getItem('role');

  const handleClick = (jobId) => {

    setId(jobId)

  };
  const formattedDateTime = (date) => {
    if (date) {
      const formattedDate = new Date(date);
      return formattedDate.toLocaleString();
    }
    return "-"
  }

  const action = (job) => {
    let path = '';
    let showLink = false;

    switch (job.jobType) {
      case 'TDSReconciliation':
        path = `/tds-job`;
        showLink = true;
        break;
      case 'TCSReconciliation':
        showLink = true;
        path = '/tcs-job';
        break;
      default:
        return null;
    }
    path = `${path}?jobId=${job.id}`;
    return showLink && job.status === 'Completed' ?
      <React.Fragment>
        <Link to={path} className="p-button-success p-button-text">View</Link>
      </React.Fragment> : null

  }

  const [configDialogActive, setConfigDialogActive] = useState(false);
  const onConfigButtonClick = () => {
    if (configDialogActive == false) {
      refresh();
    }
    setConfigDialogActive(!configDialogActive);
  }
  useEffect(() => {
    setConfigDialogActive(props.active)
  }, [props.active])
  return (
    <div className={classNames("layout-config", "right", "p-shadow-5", { 'layout-config-active': configDialogActive })} >
      <div className="layout-config-content" style={{ overflowY: 'auto' }} >
        <button className="layout-config-button" id="layout-config-button" onClick={onConfigButtonClick} style={{ position: 'fixed' }}>
          <i className="pi pi-angle-double-left" />
        </button>
        <div className="card">
          <div style={{ position: 'sticky', background: 'white', zIndex: '1', top: '0' }}><h1><b>Shortcuts</b> &nbsp;</h1></div>
          <div className="p-col-4 p-md-4 p-lg-4">
            <div className="overview clearfix">

              {role === 'ADMIN' && (
                <Link to={"/view-tds-reconciliation"} className="p-button-success p-button-text">
                  <div className="overview-icon">
                    <img src="assets/layout/images/dashboard-banking/icon-cardtransfer.png" alt="avalon-layout"
                      width="52" className="icon-transfer" />
                  </div>
                  <div className="overview-text">
                    <span className="overview-subtitle">TDS Receivable Reconciliation</span>
                  </div>
                </Link>
              )}
              {role === 'ADMIN' && (
                <Link to={"/view-34a-reconciliation"} className="p-button-success p-button-text">
                  <div className="overview-icon">
                    <img src="assets/layout/images/dashboard-banking/icon-cardtransfer.png" alt="avalon-layout"
                      width="52" className="icon-transfer" />
                  </div>
                  <div className="overview-text">
                    <span className="overview-subtitle">TDS Payable Reconciliation</span>
                  </div>
                </Link>

              )}
              <Link to={"/reports-dashboard"} className="p-button-success p-button-text">
                <div className="overview-icon">
                  <img src="assets/layout/images/dashboard-banking/icon-cardtransfer.png" alt="avalon-layout"
                    width="52" className="icon-transfer" />
                </div>
              </Link>

              <div className="overview-text">
                <span className="overview-subtitle">Reports Dashboard</span>
              </div>
            </div>
          </div>

        </div>

        <hr />
        <div className="card">
          <div style={{ position: 'sticky', background: 'white', zIndex: '1', top: '0' }}><h1><b>All Background Processes </b> &nbsp;&nbsp;<Button icon="pi pi-refresh" className="p-button-rounded p-button-primary" onClick={refresh} alt={'Refresh results'} /></h1></div>
          <Messages ref={messages} />
          <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            className={classes.root}
          >

            {

              jobsList.map((job, index) => (

                <React.Fragment key={job.id}>

                  <ListItem onClick={() => handleClick(job.id)}>
                    <ListItemIcon>
                      {job.status === 'Completed' ?
                        <DoneAllIcon style={{ color: 'green' }} />

                        :
                        job.status === 'InProgress'
                          ?
                          <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="4" />
                          :
                          job.status === 'NotStarted'
                            ?
                            <HourglassFullIcon style={{ color: 'orange', background: 'black' }} />
                            :
                            <CancelIcon style={{ color: 'red' }} />

                      }
                    </ListItemIcon>
                    <ListItemText primary={job.jobType} />
                    {id !== job.id ? <ArrowDropDownIcon /> : <ArrowDropUpIcon onClick={() => setId('-1')} />}
                  </ListItem>
                  <Collapse in={id === job.id} timeout="auto" unmountOnExit onClick={() => setId('-1')}>
                    <List component="div" disablePadding>
                      <ListItem className={classes.nested} style={{ cursor: 'pointer' }}>
                        {
                          job.id === id ?
                            <TableContainer component={Paper}>
                              <Table className={classes.table} aria-label="simple table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell><b>User Id</b></TableCell>
                                    <TableCell align="right"><b>Started At</b></TableCell>
                                    <TableCell align="right"><b>Ended At</b></TableCell>
                                    <TableCell align="right"><b>Status</b></TableCell>
                                    <TableCell align="right"><b>Action</b></TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  <TableRow>
                                    <TableCell component="th" scope="row">
                                      {job.userId}
                                    </TableCell>
                                    <TableCell align="right">{formattedDateTime(job.datetime)}</TableCell>
                                    <TableCell align="right">{formattedDateTime(job.enddatetime)}</TableCell>
                                    <TableCell align="right">{job.status}</TableCell>
                                    <TableCell align="right">{action(job)}</TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>

                            :
                            <></>
                        }
                      </ListItem>
                    </List>
                  </Collapse>
                </React.Fragment>
              ))}

          </List>

        </div>
      </div>
    </div>
  )
}



export default AppJobMenu;